var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 24,
    viewBox: "0 0 61 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1318_4454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6884 1.67686C40.6575 1.02908 40.3491 0.566385 39.763 0.288769C39.1769 0.0728455 38.6371 0.180807 38.1436 0.612656L36.154 2.64852C35.0126 3.75898 33.7325 4.62268 32.3136 5.23961C30.8638 5.82569 29.3523 6.11873 27.7792 6.11873H27.3628H25.8821H21.4403C20.6074 6.14958 19.9134 6.44262 19.3581 6.99785C18.8029 7.55309 18.5099 8.24713 18.479 9.07998V13.5219C18.5099 14.3547 18.8029 15.0487 19.3581 15.604C19.9134 16.1592 20.6074 16.4523 21.4403 16.4831V22.4056C21.4403 22.8375 21.5791 23.1922 21.8567 23.4698C22.1343 23.7474 22.489 23.8862 22.9209 23.8862H25.8821C26.314 23.8862 26.6687 23.7474 26.9463 23.4698C27.2239 23.1922 27.3628 22.8375 27.3628 22.4056V16.4831H27.7792C29.3523 16.4831 30.8638 16.7916 32.3136 17.4085C33.7325 17.9946 35.0126 18.8429 36.154 19.9533L38.1436 21.9892C38.6371 22.421 39.1769 22.529 39.763 22.3131C40.3491 22.0354 40.6575 21.5728 40.6884 20.925V14.0771C41.1202 13.8612 41.475 13.5064 41.7526 13.0129C42.0302 12.5193 42.169 11.9487 42.169 11.3009C42.169 10.6531 42.0302 10.0825 41.7526 9.58895C41.475 9.0954 41.1202 8.74067 40.6884 8.52475V1.67686ZM37.7271 5.23961V11.3009V17.3622C36.339 16.1284 34.7967 15.1876 33.1002 14.5398C31.4036 13.8612 29.63 13.5219 27.7792 13.5219H27.3628V9.07998H27.7792C29.63 9.07998 31.4036 8.74067 33.1002 8.06205C34.7967 7.41428 36.339 6.47346 37.7271 5.23961Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1318_4454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 23.69,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.324219 23.8862)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.125018a3877e65a05fcc61449249b1d4.svg";
export { ForwardRef as ReactComponent };